module.exports = __webpack_public_path__ + "img/raport-waste-icon.a279a794.svg";